import React from 'react'
import AboutHero from './AboutHero'
import FoudationInfo from './FoudationInfo'
import OurMission from './OurMission'
import Footer from '../../components/Footer/Footer'

const About = () => {

  return (
    <div>
      <AboutHero/>
      <FoudationInfo/>
      <OurMission/>
      <Footer/>
    </div>
  )
}

export default About
